import { useEffect, useState } from 'react';
import { FaArrowLeft, FaCheckCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { validateEmail, validatePhone } from '../components/FormValidation';
import { FormError } from '../components/FormError';
import { useGetProduct } from '../services/hooks/product/product';
import { v4 as uuidv4 } from 'uuid';
import { useAddTransaction } from '../services/hooks/transaction/transaction';
import SubscriptionPackage from '../components/SubscriptionPackage';

interface Plan {
  id: string;
  name: string;
  price: number;
  period: string;
  features: string[];
  free_trial: Boolean;
  ctaText: Boolean;
  highlight: number;
  badge: Boolean;
  borderColor: number;
  description: string;
}

const SubscriptionCard = ({
  plan,
  isSelected,
  onClick,
  disabled,
}: {
  plan: Plan;
  isSelected: boolean;
  onClick: () => void;
  disabled: boolean;
}) => (
  <div
    onClick={() => !disabled && onClick()}
    className={`bg-gray-100 shadow-sm border-2 rounded-xl p-6 transition-all ${
      isSelected ? 'border-[#3723B5] bg-pink-50' : 'border-gray-200'
    } ${
      disabled ? 'cursor-not-allowed' : 'hover:border-[#3723B5] cursor-pointer'
    }`}
  >
    <div
    // className="bg-gray-100 p-6 rounded-xl shadow-sm"
    >
      <div className="mb-4">
        <h3 className="text-xl font-bold mb-1">{plan.name}</h3>
        <p className="text-sm text-gray-600">{plan.description}</p>
      </div>

      <div className="space-y-3 mb-6">
        {plan.features.map((feature, index) => (
          <div key={index} className="flex items-center space-x-2">
            <FaCheckCircle className="text-[#3723B5] shrink-0" />
            <span className="text-sm">{feature}</span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between mb-4">
        <div>
          {/* <span className="text-sm text-gray-600">Starting from</span> */}
          <div className="text-xl font-bold">
            <span className="text-xl font-bold text-[#3723B5]">
              {plan.price ? `Rp ${plan.price}` : 'Gratis'}
            </span>
          </div>
        </div>
        <div className="text-right">
          <div className="text-[#3723B5] font-bold">{plan.period}</div>
          <div className="text-sm text-gray-600">No commitment</div>
        </div>
      </div>
    </div>
  </div>
);

export default function Subscribe() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-white">
      {/* Navigation Bar */}
      <div className="h-14 flex items-center px-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700"
        >
          <FaArrowLeft className="mr-2" />
          <span>Kembali</span>
        </button>
      </div>

      <SubscriptionPackage />
    </main>
  );
}
